import { Container, Content, Heading } from "./index.styles";
import UI from "@mile-meeting/mile-ui";
import { useEffect, useState } from "react";

import {
  AlarmChannel,
  getAlarmSettings,
  updateMeetingExtendAlarm,
  updateMeetingAlarm,
  updateMeetingRsvAlarm,
  updateMeetingRsvAlarmChannel,
  updateMeetingAlarmChannel,
  updateMeetingExtendAlarmChannel,
} from "apis/alarm-settings";
import { useToast } from "hook/useToast";

import { getMessengers } from "apis/messangers";
import { changeAlarmChannel } from "apis/meeting-room-complain/alarm-receiver";
import { changeDeviceAlarmChannel } from "apis/meeting-room-device";
import RoomUsageAlertChannelSetting from "./uis/room-usage-alert-channel-setting";
import { TAlarm } from "apis/alarm-settings";
import {
  ComplainNotificationSetting,
  DeviceManageNotificationSetting,
  MeetingExtendNotificationSetting,
  MeetingNotificationSetting,
  ReservationNotificationSetting,
} from "uis/PolicyManage";

//TODO: isShow props를 사용하여 RoomUsageAlertChannelSetting 컴포넌트를 렌더링합니다.
const MyAlarmManage = () => {
  const { showToast } = useToast();
  const [isSlackConntected, setIsSlackConntected] = useState<boolean>(false);
  const [isMeetingAlarmEnabledByAdmin, setIsMeetingAlarmEnabledByAdmin] = useState<boolean>(true);
  const [rsvAlarm, setRsvAlarm] = useState<boolean>(false);
  const [meetingAlarm, setMeetingAlarm] = useState<boolean>(false);
  const [extendAlarm, setExtendAlarm] = useState<boolean>(false);
  const [rsvAlarmChannel, setRsvAlarmChannel] = useState<AlarmChannel>(AlarmChannel.EMAIL);
  const [meetingAlarmChannel, setMeetingAlarmChannel] = useState<AlarmChannel>(AlarmChannel.EMAIL);
  const [extendAlarmChannel, setExtendAlarmChannel] = useState<AlarmChannel>(AlarmChannel.EMAIL);
  const [isComplainHost, setIsComplainHost] = useState<boolean>(false);
  const [complainAlarmChannel, setComplainAlarmChannel] = useState<AlarmChannel>(AlarmChannel.EMAIL);
  const [isDeviceHost, setIsDeviceHost] = useState<boolean>(false);
  const [deviceAlarmChannel, setDeviceAlarmChannel] = useState<AlarmChannel>(AlarmChannel.EMAIL);
  const [alarmSettingData, setAlarmSettingData] = useState<TAlarm>();

  const getMyMessengers = async () => {
    const res = await getMessengers();
    if (res.success) {
      const messengers = res.data?.map((item) => item.messengerProvider);
      if (messengers?.includes("SLACK")) {
        setIsSlackConntected(true);
      }
    }
  };

  const getMyAlarmSetting = async () => {
    const res = await getAlarmSettings();
    if (res.success) {
      setAlarmSettingData(res.data);
      setIsMeetingAlarmEnabledByAdmin(res.data?.isMeetingAlarmEnabledByAdmin ?? true);
      setRsvAlarm(res.data?.isMeetingRsvAlarmEnabled ?? false);
      setMeetingAlarm(res.data?.isMeetingAlarmEnabled ?? false);
      setExtendAlarm(res.data?.isMeetingExtendAlarmEnabled ?? false);

      setRsvAlarmChannel(res.data?.meetingRsvAlarmChannel ?? AlarmChannel.EMAIL);
      setMeetingAlarmChannel(res.data?.meetingAlarmChannel ?? AlarmChannel.EMAIL);
      setExtendAlarmChannel(res.data?.meetingExtendAlarmChannel ?? AlarmChannel.EMAIL);

      if (res.data?.meetingRoomComplainHostAlarmInfo) {
        setIsComplainHost(true);
        setComplainAlarmChannel(res.data.meetingRoomComplainHostAlarmInfo.hostAlarmChannel);
      }
      if (res.data?.meetingRoomDeviceHostAlarmInfo) {
        setIsDeviceHost(true);
        setDeviceAlarmChannel(res.data.meetingRoomDeviceHostAlarmInfo.hostAlarmChannel);
      }
    }
  };

  const onHandleChangeRsvAlarm = async (isMeetingRsvAlarmEnabled: boolean) => {
    const res = await updateMeetingRsvAlarm(isMeetingRsvAlarmEnabled);
    if (res.success) {
      setRsvAlarm(isMeetingRsvAlarmEnabled);

      if (isMeetingRsvAlarmEnabled) showToast("예약 알림이 활성화되었습니다.", "success");
      else showToast("예약 알림이 비활성화되었습니다.", "success");
    } else {
      showToast(res.message ?? "설정 변경에 실패했습니다. 다시 시도해 주세요.", "error");
    }
  };
  const onHandleChangeMeetingAlarm = async (isMeetingAlarmEnabled: boolean) => {
    const res = await updateMeetingAlarm(isMeetingAlarmEnabled);
    if (res.success) {
      setMeetingAlarm(isMeetingAlarmEnabled);

      if (isMeetingAlarmEnabled) showToast("회의 알림이 활성화되었습니다.", "success");
      else showToast("회의 알림이 비활성화되었습니다.", "success");
    } else {
      showToast(res.message ?? "설정 변경에 실패했습니다. 다시 시도해 주세요.", "error");
    }
  };
  const onHandleChangeExtendAlarm = async (isMeetingExtendAlarmEnabled: boolean) => {
    const res = await updateMeetingExtendAlarm(isMeetingExtendAlarmEnabled);
    if (res.success) {
      setExtendAlarm(isMeetingExtendAlarmEnabled);

      if (isMeetingExtendAlarmEnabled) showToast("연장 알림이 활성화되었습니다.", "success");
      else showToast("연장 알림이 비활성화되었습니다.", "success");
    } else {
      showToast(res.message ?? "설정 변경에 실패했습니다. 다시 시도해 주세요.", "error");
    }
  };

  const onHandleChangeRsvAlarmChannel = async (channel: AlarmChannel) => {
    if (rsvAlarmChannel === channel) return;

    const res = await updateMeetingRsvAlarmChannel(channel);
    if (res.success) {
      setRsvAlarmChannel(channel);
      showToast("예약 알림 채널이 변경되었습니다.", "success");
    } else {
      showToast(res.message ?? "설정 변경에 실패했습니다. 다시 시도해 주세요.", "error");
    }
  };
  const onHandleChangeMeetingAlarmChannel = async (channel: AlarmChannel) => {
    if (meetingAlarmChannel === channel) return;

    const res = await updateMeetingAlarmChannel(channel);
    if (res.success) {
      setMeetingAlarmChannel(channel);
      showToast("회의 알림 채널이 변경되었습니다.", "success");
    } else {
      showToast(res.message ?? "설정 변경에 실패했습니다. 다시 시도해 주세요.", "error");
    }
  };
  const onHandleChangeExtendAlarmChannel = async (channel: AlarmChannel) => {
    if (extendAlarmChannel === channel) return;

    const res = await updateMeetingExtendAlarmChannel(channel);
    if (res.success) {
      setExtendAlarmChannel(channel);
      showToast("연장 알림 채널이 변경되었습니다.", "success");
    } else {
      showToast(res.message ?? "설정 변경에 실패했습니다. 다시 시도해 주세요.", "error");
    }
  };

  const onHandleChangeComplainAlarmChannel = async (channel: AlarmChannel) => {
    if (complainAlarmChannel === channel) return;

    const res = await changeAlarmChannel(channel);
    if (res.success) {
      setComplainAlarmChannel(channel);
      showToast("민원 알림 채널이 변경되었습니다.", "success");
    } else {
      showToast(res.message ?? "설정 변경에 실패했습니다. 다시 시도해 주세요.", "error");
    }
  };

  const onHandleChangeDeviceAlarmChannel = async (channel: AlarmChannel) => {
    if (deviceAlarmChannel === channel) return;

    const res = await changeDeviceAlarmChannel(channel);
    if (res.success) {
      setDeviceAlarmChannel(channel);
      showToast("회의실 기기 관리 알림 채널이 변경되었습니다.", "success");
    } else {
      showToast(res.message ?? "설정 변경에 실패했습니다. 다시 시도해 주세요.", "error");
    }
  };

  useEffect(() => {
    getMyMessengers();
    getMyAlarmSetting();
  }, []);

  return (
    <Container
      style={{
        minWidth: 1140,
        boxSizing: "border-box",
      }}
    >
      <Heading>
        <UI.Typography
          type="title03"
          fontStyle="bold"
          color="var(--alias-color-label-neutral)"
          style={{
            padding: "24px 20px",
          }}
        >
          나의 알림 설정
        </UI.Typography>
      </Heading>

      <Content>
        {alarmSettingData && (
          <RoomUsageAlertChannelSetting
            channel={alarmSettingData?.meetingUsageConfirmAlarmChannel}
            isShow={alarmSettingData?.meetingUsageConfirmAlarmChannel !== null}
            isSlackConnected={isSlackConntected}
          />
        )}
        <ReservationNotificationSetting
          isActivated={rsvAlarm}
          channel={rsvAlarmChannel}
          onChange={onHandleChangeRsvAlarm}
          onChangeChannel={onHandleChangeRsvAlarmChannel}
          isSlackConnected={isSlackConntected}
        />
        <MeetingNotificationSetting
          isActivated={meetingAlarm}
          channel={meetingAlarmChannel}
          onChange={onHandleChangeMeetingAlarm}
          onChangeChannel={onHandleChangeMeetingAlarmChannel}
          isSlackConnected={isSlackConntected}
          isMeetingAlarmEnabledByAdmin={isMeetingAlarmEnabledByAdmin}
        />
        <MeetingExtendNotificationSetting
          isActivated={extendAlarm}
          channel={extendAlarmChannel}
          onChange={onHandleChangeExtendAlarm}
          onChangeChannel={onHandleChangeExtendAlarmChannel}
          isSlackConnected={isSlackConntected}
        />
        <ComplainNotificationSetting
          isActivated={isComplainHost}
          channel={complainAlarmChannel}
          onChangeChannel={onHandleChangeComplainAlarmChannel}
          isSlackConnected={isSlackConntected}
        />
        <DeviceManageNotificationSetting
          isActivated={isDeviceHost}
          channel={deviceAlarmChannel}
          onChangeChannel={onHandleChangeDeviceAlarmChannel}
          isSlackConnected={isSlackConntected}
        />
      </Content>
    </Container>
  );
};

export default MyAlarmManage;
